import { Col, Row } from "reactstrap"
import styles from "./AdPlacement.module.scss"
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown"

const AdPlacement = () => {
  return (
    <div>
      <div className={styles["heading"]}>Ad Placement</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 row-gap-1 align-items-center">
            <Col lg={3} xl={2}>Placement Type:</Col>
            <Col lg={5} xl={4}>
              <div className="border border-subtle-secondary rounded p-2">
                <CustomDropdown title="Shop Now" muted />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default AdPlacement
